import Model from "./base/model";

class RouteTable extends Model {
  resourceName() {
    return "route_tables";
  }

  fields() {
    return {
      shipper_transporter_id: "",
      user_import_id: "",
      user_shipper_id: "",
      user_transporter_id: "",
      vehicle_type_id: "",
      vehicle_option_id: "",
      project: "",
      transport_modal: "",
      contract: "",
      description: "",
      value: "",
      value_calculation: "",
      shipper_approval: "",
      transporter_approval: "",
      shipper_justification: "",
      transporter_justification: "",
      lead_time: "",
      business_day: "",
      closure: "",
      project_name: "",
      shipper: "",
      transporter: "",
      supplier: "",
      origin: {jsonApi: "hasOne", type: "cities"},
      destiny: {jsonApi: "hasOne", type: "cities"},
      vehicle_type: {jsonApi: "hasOne", type: "vehicle_types"},
      vehicle_option: {jsonApi: "hasOne", type: "vehicle_options"},
      rates: {jsonApi: "hasMany", type: "route_tables_rates"},
      files: {jsonApi: "hasMany", type: "route_tables_files"},
      date_start: "",
      date_end: "",
      active: "",
    };
  }

  async approveTable(id, data) {
    return this.request(
      `route_tables/approve_table/${id}`,
      "POST",
      {},
      data
    );
  }

  async approveProject(data) {
    return this.request(
      `route_tables/approve_project`,
      "POST",
      {},
      data
    );
  }

  async closureProject(data) {
    return this.request(
      `route_tables/closure_project`,
      "POST",
      {},
      data
    );
  }

  async getProjects(options) {
    return this.request(
      `route_tables_projects`,
      "GET",
      options,
      null
    );
  }


}

export default new RouteTable();
